/* global firebase */

import { useState, useEffect } from 'react';

const loadKeys = firebase.functions().httpsCallable('keys');

export default function useKey(key) {
  const [state, setState] = useState({});
  useEffect(() => {
    loadKeys().then(res => setState(res.data));
  }, []);
  return state[key];
}